<template>
  <div class="takePhotos tp-bg portrait-mode">
    <!-- 竖屏提示 -->
    <div class="portrait-warning" v-if="showPortraitWarning">
      <div class="warning-content">
        <div class="warning-icon">📱</div>
        <div class="warning-text">请将设备旋转至竖屏模式拍照作品</div>
      </div>
    </div>

    <!-- 页面内容 -->
    <div class="page-content">

      <div class="flex-align-between">
        <div></div>
        <div class="flex-align-center example-button" @click="openExample">
          <img alt="" class="ico" src="@/assets/student/tp-ico.png">
          <span>拍照示例</span>
        </div>
      </div>

      <div class="tips-text">
        请将作品四周边框拍摄完整
      </div>

      <div class="flex-column-center">
        <div class="tp-photos">
          <!-- 预览视频或已拍摄图片 -->
          <video v-show="!isCaptured" ref="previewVideo" autoplay playsinline muted></video>
          <canvas v-show="isCaptured" ref="photoCanvas"></canvas>
        </div>

        <div class="tp-shoot" @click="onShootClick">
          拍照
        </div>
      </div>


    </div>

    <div class="photo-example flex-column-center" v-if="isExample">
      <div class="photo-example-content">
        <img src="@/assets/student/photo-example.webp" class="img" alt="">
        <div class="close" @click="closeExample"></div>
      </div>
    </div>


  </div>
</template>
<script>
export default {
  components: {},
  name: "StudentFrontendClassMates",
  data() {
    return {
      numPages: null,
      selectedStudent: null,
      isSubmit: null,
      showPortraitWarning: false,
      mediaStream: null,
      isCaptured: false,
      isExample: false,
    };
  },
  computed: {
    message: {
      get() {

      },
      set() {

      }
    }
  },
  created() {

  },
  mounted() {
    this.checkOrientation();
    this.addOrientationListener();
    this.startCamera();
  },
  methods: {

    openExample() {
        this.isExample = true;
    },

    closeExample() {
     this.isExample = false;
    },

    // 检查当前屏幕方向
    checkOrientation() {
      const isLandscape = window.innerWidth > window.innerHeight;
      this.showPortraitWarning = isLandscape;
    },

    // 添加屏幕方向变化监听器
    addOrientationListener() {
      window.addEventListener('resize', this.checkOrientation);
      window.addEventListener('orientationchange', () => {
        // 延迟检查，等待方向变化完成
        setTimeout(() => {
          this.checkOrientation();
        }, 100);
      });
    },

    // 移除监听器（组件销毁时）
    removeOrientationListener() {
      window.removeEventListener('resize', this.checkOrientation);
    },

    async startCamera() {
      try {
        const constraints = {
          video: {
            facingMode: 'environment',
          },
          audio: false,
        };
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.mediaStream = stream;
        const videoEl = this.$refs.previewVideo;
        if (videoEl) {
          videoEl.srcObject = stream;
          // 等视频元数据就绪后将画布适配到容器尺寸
          videoEl.onloadedmetadata = () => {
            videoEl.play();
            this.fitMediaElements();
          };
        }
      } catch (err) {
        console.error('启动摄像头失败:', err);
        this.$message && this.$message.error('无法访问摄像头，请检查浏览器权限设置');
      }
    },

    stopCamera() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop());
        this.mediaStream = null;
      }
    },

    fitMediaElements() {
      // 将 canvas 尺寸设置为容器实际像素尺寸
      const container = this.$el.querySelector('.tp-photos');
      const canvas = this.$refs.photoCanvas;
      if (container && canvas) {
        const { clientWidth, clientHeight } = container;
        canvas.width = clientWidth;
        canvas.height = clientHeight;
      }
    },

    onShootClick() {
      if (!this.isCaptured) {
        this.capturePhoto();
      } else {
        // 已拍摄时再次点击可重拍
        this.isCaptured = false;
        this.fitMediaElements();
      }
    },



    capturePhoto() {
      const videoEl = this.$refs.previewVideo;
      const canvas = this.$refs.photoCanvas;
      if (!videoEl || !canvas) return;
      this.fitMediaElements();
      const ctx = canvas.getContext('2d');
      // 将视频帧按容器比例绘制，保持内容完整显示
      const container = this.$el.querySelector('.tp-photos');
      const cw = container.clientWidth;
      const ch = container.clientHeight;
      const vw = videoEl.videoWidth;
      const vh = videoEl.videoHeight;
      if (!vw || !vh) return;

      // 计算 cover 填充
      const scale = Math.max(cw / vw, ch / vh);
      const dw = vw * scale;
      const dh = vh * scale;
      const dx = (cw - dw) / 2;
      const dy = (ch - dh) / 2;

      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(videoEl, dx, dy, dw, dh);
      this.isCaptured = true;
      this.saveCanvasToLocal();
    },

    saveCanvasToLocal() {
      const canvas = this.$refs.photoCanvas;
      if (!canvas) return;
      // 以 JPEG 导出，控制体积
      const dataUrl = canvas.toDataURL('image/jpeg', 0.92);

      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const filename = `photo_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.jpg`;

      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = filename;

      // 某些移动端浏览器可能忽略 download 属性，打开新标签以便用户长按保存
      if (typeof link.download === 'undefined') {
        window.open(dataUrl, '_blank');
        return;
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 恢复为可再次拍照的状态，并清空画布
      this.isCaptured = false;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    }
  },

  beforeDestroy() {
    this.removeOrientationListener();
    this.stopCamera();
  },
};
</script>

<style lang="less" scoped>
@import "student.less";
</style>
<style>
/* 强制竖屏显示的样式 */
.portrait-mode {
  /* 在横屏时限制最大宽度，强制显示为竖屏效果 */
  max-width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
}

.tp-bg {
  width: 100%;
  height: 100vh;
  background: url("../../assets/student/takePhotos-bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: bottom center;
  box-sizing: border-box;
}

.takePhotos {
  padding: 180px;

  .example-button {
    padding: 0 50px;
    height: 150px;
    background: #21BD99;
    border-radius: 75px;
    color: #fff;
    font-size: 80px;

    .ico {
      width: 75px;
      height: 75px;
    }
  }

  .tips-text {
    font-weight: 400;
    font-size: 64px;
    color: #333333;
    text-align: center;
    margin-top:70px;
  }
  .tp-photos{
    margin-top: 70px;
    width: 1562px;
    height: 2148px;
    background: #ccc;
    border: 7px solid #FFFFFF;
    overflow: hidden;
  }
  .tp-photos video,
  .tp-photos canvas{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
  .tp-shoot{
    margin-top: 70px;
    width: 352px;
    height: 352px;
    background: #FFFFFF;
    border-radius: 50%;
    border: 7px solid #B7B7B7;
    line-height: 352px;
    text-align: center;
    font-size: 80px;
    color: #333333;
  }
}

.photo-example{
  z-index: 100;
  position: absolute;
  inset: 0;
  height:100vh;
  width: 100%;
  background:rgba(0, 0, 0, 0.5);
  .photo-example-content{
    width: 1562px;
    height: auto;
  }
  .img{
    width: 1562px;
    height: auto;
    display: block;
  }
  .close{
    height:300px;
    width:500px;
    position: absolute;
    bottom:350px;
    left: 50%;
    transform: translateX(-50%);
  }
}

/* 横屏时的样式调整 */
@media screen and (orientation: landscape) and (max-height: 600px) {
  .portrait-mode {
    /* 在横屏时，通过transform缩放来模拟竖屏效果 */
    transform: scale(0.8);
    transform-origin: top center;
    width: 100vw;
    height: 125vh; /* 增加高度以补偿缩放 */
  }
}

/* 竖屏提示样式 */
.portrait-warning {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
}

.warning-content {
  background: white;
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  max-width: 80%;
  animation: fadeInScale 0.3s ease-out;
}

.warning-icon {
  font-size: 60px;
  margin-bottom: 20px;
  animation: rotate 2s linear infinite;
}

.warning-text {
  font-size: 18px;
  color: #333;
  line-height: 1.5;
  font-weight: 500;
}

/* 动画效果 */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 页面内容样式 */
.page-content {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* 确保在移动设备上的最佳显示效果 */
@media screen and (max-width: 768px) {
  .portrait-mode {
    /* 在移动设备上强制竖屏显示 */
    min-height: 100vh;
    max-height: 100vh;
    overflow-y: auto;
  }

  .warning-content {
    padding: 30px 20px;
    margin: 0 20px;
  }

  .warning-text {
    font-size: 16px;
  }
}


</style>
